import SuccessPanel from "./success-panel";
export default SuccessPanel;
